module.exports = __webpack_public_path__ + "img/New Year 2.6f51cb8b.jpeg";